import React from 'react';

import { styled } from '@mui/material/styles';

import { TextField, TextFieldProps } from '@mui/material';

export const OutlinedTextField: React.FC<TextFieldProps> = (
  props: TextFieldProps,
) => <TextField variant="outlined" {...props} type="text" size="small" />;

export const TextFieldFormStyledNoPadding = styled(OutlinedTextField)`
  width: 250px;
`;

export const TextFieldFormStyled = styled(OutlinedTextField)`
  width: 250px;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const TextFieldFormStyledNarrow = styled(OutlinedTextField)`
  width: 40px;
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
